// libraries
import { useHistory, useLocation } from 'react-router-dom';

import { Tag, Table, Typography } from 'antd';
import { ArrowRightOutlined, CameraOutlined, CheckOutlined } from '@ant-design/icons';

// components
import { SharedTable } from '../../../shared/table';

// utils
import { txt } from '../../../../locales/i18n';
import { formatDate } from '../../../../utils/date';

export function ActivityListContentDesktop(props: any): JSX.Element {
	const history = useHistory();
	const location = useLocation();

	function renderUser(user: any, record: any): JSX.Element {
		return (
			<>
				<Typography.Link>{record.email}</Typography.Link>
				<br />
				<span>{user}</span>
			</>
		);
	}

	function renderCheckmark(value: any): null | JSX.Element {
		if (Boolean(value) === false) return null;
		return <CheckOutlined />;
	}

	function renderDurationDates(dates: any[] | null): JSX.Element {
		if (dates === null || dates.length !== 1) {
			return <Tag color="blue">{txt('global.recurring')}</Tag>;
		}

		const { start_date, end_date } = dates[0];

		return (
			<>
				<span>{formatDate(start_date)}</span>
				<ArrowRightOutlined style={{ margin: '0 0.8rem' }} />
				<span>{formatDate(end_date)}</span>
			</>
		);
	}

	function renderCrawler(crawler: string | null): JSX.Element | null {
		if (crawler === null) return null;
		return <Tag color="blue">{crawler}</Tag>;
	}

	return (
		<SharedTable
			rowKey="id"
			loading={props.loading}
			dataSource={props.dataSource}
			onRow={(record: any) => ({
				onClick: () => {
					history.replace({ hash: String(record.id), search: location.search });
					history.push(`/activities/${record.id}`)
				},
			})}
		>
			<Table.Column dataIndex="created" title={txt('global.created')} width="10rem" render={formatDate} />
			<Table.Column dataIndex="id" title="ID" width="6rem" />
			<Table.Column dataIndex="activityTitle" width="12rem" title={txt('global.title')} ellipsis />
			<Table.Column dataIndex="universeTitle" width="10rem" title={txt('global.universe')} />

			<Table.Column
				dataIndex="approved"
				title={<CheckOutlined />}
				render={renderCheckmark}
				width="3rem"
				align="center"
			/>

			<Table.Column
				dataIndex="imageId"
				title={<CameraOutlined />}
				render={renderCheckmark}
				width="3rem"
				align="center"
			/>
			<Table.Column
				dataIndex="dates"
				title={txt('global.duration')}
				render={renderDurationDates}
				align="center"
				width="22rem"
			/>
			<Table.Column dataIndex="municipalityName" title={txt('global.municipality')} width="8rem" />
			<Table.Column dataIndex="username" title={txt('global.user')} render={renderUser} width="10rem" ellipsis />
			<Table.Column dataIndex="crawler" title="Crawler" render={renderCrawler} width="8rem" />
		</SharedTable>
	);
}
